import { ReactNode, useCallback } from "react";

import { IconType } from "react-icons";

import { WarningTwoIcon } from "@chakra-ui/icons";
import { Button, ComponentWithAs, HStack, IconProps, UseDisclosureReturn } from "@chakra-ui/react";

import IconModal from "@/components/shared/IconModal";

type Props = {
  header?: ReactNode;
  description?: ReactNode;
  onConfirm: () => void;
  onCancel?: () => void;
  icon?: ComponentWithAs<"svg", IconProps> | IconType;
  isLoading?: boolean;
  hideCancel?: boolean;
  confirmText?: string;
} & UseDisclosureReturn;

function ConfirmModal({
  description,
  header,
  onConfirm,
  onCancel,
  icon,
  isLoading,
  hideCancel,
  confirmText = "Confirm",
  ...modalProps
}: Props) {
  const onCancelCallback = useCallback(() => {
    onCancel && onCancel();
    modalProps.onClose();
  }, [onCancel, modalProps]);

  return (
    <IconModal
      body={description}
      footer={
        <HStack>
          {hideCancel ? null : (
            <Button variant="outline" onClick={onCancelCallback}>
              Cancel
            </Button>
          )}
          <Button isLoading={isLoading} onClick={onConfirm}>
            {confirmText}
          </Button>
        </HStack>
      }
      header={header ?? "Are you sure?"}
      icon={(icon as ComponentWithAs<"svg", IconProps>) ?? WarningTwoIcon}
      {...modalProps}
    />
  );
}

export default ConfirmModal;
